export type IUserPlayLevel = '1' | '2' | '3' | '4' | '5';

export const userPlayLevels: Record<IUserPlayLevel, string> = {
  1: '0-500',
  2: '500-1000',
  3: '1000-1500',
  4: '1500-2000',
  5: '2000+',
};
